import { types } from 'mobx-state-tree';
var ModalStore = types
    .model({ activeModal: types.maybe(types.string) })
    .named('ModalStore')
    .volatile(function (_self) { return ({ activeParameters: undefined, previousModals: [] }); })
    .views(function (self) { return ({
    get modalIsOpen() {
        return self.activeModal !== undefined;
    },
    showModal: function (modalKey) {
        return self.activeModal === modalKey;
    },
    getActiveParameters: function (modalKey) {
        if (self.activeModal !== modalKey) {
            return undefined;
        }
        return self.activeParameters;
    },
}); })
    .actions(function (_self) { return ({
/*
openModal<
  K extends (keyof OnlyNever<IModalKeys>)
>(modalToOpen: K): void {
  // this implementation is never invoked, because its overwritten by the following actions block
  console.log(modalToOpen)
}*/
}); })
    .actions(function (self) { return ({
    /*openModal<
      K extends (keyof OmitNever<IModalKeys>), // all its keys
      V extends IModalKeys[K] // types of keys, once K is specified, it's narrowed to related type.
    >(modalToOpen: K, parameters: V): void {
      self.activeModal = modalToOpen;
      self.activeParameters = parameters;
    },*/
    openModal: function (modalToOpen, parameters) {
        if (self.activeModal) {
            self.previousModals.push({
                key: self.activeModal,
                parameters: self.activeParameters
            });
        }
        self.activeModal = modalToOpen;
        self.activeParameters = parameters;
    },
    closeModal: function () {
        var latestPrevious = self.previousModals.pop();
        if (latestPrevious && 10 < 5) {
            self.activeModal = latestPrevious.key;
            self.activeParameters = latestPrevious.parameters;
            return;
        }
        self.activeModal = undefined;
        self.activeParameters = undefined;
    },
}); });
export default ModalStore;
//# sourceMappingURL=ModalStore.js.map